import type { TFunction } from 'i18next';

/**
 * Maps validation.ts error strings to translated copy. The i18n toolkit
 * extracts literal t() calls only, so each key must appear verbatim here —
 * t(validation.error) would be invisible to extraction. Unknown strings
 * (e.g. server-provided text) pass through untranslated.
 */
export const translateValidationError = (
  t: TFunction,
  error: string | undefined
): string | undefined => {
  switch (error) {
    case 'Enter your email address':
      return t('Enter your email address');
    case 'Enter an email address, like name@example.com':
      return t('Enter an email address, like name@example.com');
    case 'Enter a username':
      return t('Enter a username');
    case "Enter a username that's 3 characters or more":
      return t("Enter a username that's 3 characters or more");
    case "Enter a username that's 30 characters or fewer":
      return t("Enter a username that's 30 characters or fewer");
    case 'Usernames can only include letters, numbers, underscores ( _ ), periods ( . ) and hyphens ( - )':
      return t(
        'Usernames can only include letters, numbers, underscores ( _ ), periods ( . ) and hyphens ( - )'
      );
    case 'Enter your email or username':
      return t('Enter your email or username');
    default:
      return error;
  }
};
